import React, {useState} from "react"
import {observer} from "mobx-react-lite"
import SingleTable from "../../components/SingleTable"
import TableHeaderSearch from "../../components/TableHeaderSearch/index"
import {UseStores} from "../../hooks/UseStores"

const Locations = ({data}) => {
  const {locStore, paginationStore, gtMapStore} = UseStores()
  const [filterObj, setFilterObj] = useState({name: "", address: ""})

  const handleSearch = ({k, v}) => {
    paginationStore.currentPage = 1
    console.log(k, v)
    setFilterObj({...filterObj, [k]: v})
  }

  const filterData = (data) => {
    //  for search data in table
    let filtered = data.filter((item) => {
      // let kArr = Object.keys(filterObj);
      return (
        item["name"]
          .replace(/\s*,\s*/g, ",")
          .toLowerCase()
          .trim()
          .includes(
            filterObj["name"]
              .replace(/\s*,\s*/g, ",")
              .toLowerCase()
              .trim()
          ) &&
        item["address"]
          .replace(/\s*,\s*/g, ",")
          .toLowerCase()
          .trim()
          .includes(
            filterObj["address"]
              .replace(/\s*,\s*/g, ",")
              .toLowerCase()
              .trim()
          )
      )
    })
    return filtered
  }

  /* columns specifies no of column for table header. take list of oblects.
        // name specifies label, can pass your own component.
        selector specify key of our data column
        sortable specify sorting to be done. if false no sorting will be perform.
        width specify columns width.
        class specify class name for which you can style table head cells
        ConditionalCellStyles - used for specify custom styling for cells.
                              - take list of objects.
                              - when specify a function for matching cell value
                              - class specify classname, which you can define in your component,
                                it will render to cell matching to when condition */
  const columns = [
    {
      name: (
        <TableHeaderSearch
          name="name"
          handleSearch={handleSearch}
          placeholder="Business Name"
        />
      ),
      key: "name",
      sortable: true,
      width: "32",
    },
    {
      name: (
        <TableHeaderSearch
          name="address"
          handleSearch={handleSearch}
          placeholder="Address"
        />
      ),
      key: "address",
      sortable: false,
      width: "48",
      headClass: "", // // used for styling head cells
      class: "", // used for styling all cells
      /* DON'T REMOVE. Uncomment this and styling in indes.scss to
                check functionality of custom cell styling */

      // conditionalCellStyles:[
      //     {
      //     when: val => val== "105 Longview Dr,Wartburg,TN,37887",
      //     class:'pink-background'
      // },
      // {
      //     when: val => val== "4343 E Main ST,WHITEHALL,OH,43213",
      //     class:'green-background'
      // }
      // ]
    },
    {
      name: "Status",
      key: "status",
      sortable: true,
      width: "20",
      headClass: "status",
    },
  ]

  const onRowClick = ({id, lat, lon}) => {
    console.info("location row click")
    console.info("onRowClick -> id", id)
    console.info("onRowClick -> lat, lon", lat, lon)
    locStore.setPoiId(id)
    gtMapStore.setMapObj({
      geo: {geoType: "POI", geoId: id, lat: lat, lon: lon},
      showLoader: false,
      brandId: null,
      categoryId: null,
      locationGroupId: null,
      mapGeos: {STATE: null, DMA: null},
    })
  }

  let filteredData

  if (data.length > 0) {
    let brandPoiData = []
    data.forEach((val) => {
      let poiObj = {}
      poiObj["id"] = val["id"] // need to use when we will have unique id
      poiObj["name"] = val["name"]
      let address = val["address"] ? val["address"] + ", " : ""
      let city = val["city"] ? val["city"] + ", " : ""
      let state = val["state"] ? val["state"] + " " : ""
      let zip = val["zip"] ? val["zip"] : ""
      poiObj["address"] = address + city + state + zip
      poiObj["status"] = val["status"]
      poiObj["lat"] = val["latitude"]
      poiObj["lon"] = val["longitude"]
      brandPoiData.push(poiObj)
    })
    filteredData = filterData(brandPoiData)
  }
  /* SingleTable component take props as
    data specify data need to render in table body
    columns specify no of columns in table.
    pagination - true is used for pagination needed with table. default-false
    onRowClick - specify custom functionality on table row click
    selectableRows - true is used for default first row selection, and show highlighted row on
                     selection and hover, default-false , it use id key used in data.
    */
  return (
    <div className="location-container">
      {data.length > 0 ? (
        <SingleTable
          data={filteredData}
          columns={columns}
          pagination={true}
          onRowClick={onRowClick}
          selectableRows={true}
          searchKey={filterObj.name || filterObj.address}
        />
      ) : (
        <div className="no-locations-wrapper">
          {" "}
          <h6 className="no-locations">No Brand Locations Exist. </h6>
        </div>
      )}
    </div>
  )
}
export default observer(Locations)
